import React, { useState, useEffect } from 'react';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import chevron from 'moods-stylesheets/src/icons/icon__ui--chevron-down-xbold.svg';
import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import moods from '../moods-theme';

const theme = createTheme(moods);

export function SelectDropdown({ onChange = () => {}, values = [], defaultValue, placeholder, classes = {} }) {
  const [value, setValue] = useState(placeholder ? '_placeholder_' : defaultValue || values[0]?.[0]);

  useEffect(() => {
    setValue(defaultValue || value);
  }, [defaultValue, values]);

  return (
    <div>
      <ThemeProvider theme={theme}>
        <FormControl variant="outlined">
          <Select
            IconComponent={chevron}
            classes={classes}
            value={value}
            onChange={(event) => {
              const newValue = event.target.value;
              setValue(newValue);
              onChange(newValue);
            }}
            MenuProps={{
              disableScrollLock: true,
              getContentAnchorEl: null,
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
              },
            }}
          >
            {placeholder ? (
              <MenuItem value="_placeholder_" data-option disabled>
                {placeholder}
              </MenuItem>
            ) : null}

            {values.map(([itemValue, label]) => (
              <MenuItem value={itemValue} data-option key={`SelectDropdown-item:${itemValue}`}>
                {label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </ThemeProvider>
    </div>
  );
}
